import script from "./ErrorPopupIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorPopupIndex.vue?vue&type=script&setup=true&lang=js"

import "./ErrorPopupIndex.vue?vue&type=style&index=0&id=feb6d7a2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-feb6d7a2"]])

export default __exports__